var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-spinner spinner-border text-secondary",class:`loading-spinner--${_vm.size}`,attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])
}
var staticRenderFns = []

export { render, staticRenderFns }